/**
 * Build the release-notes deep-link URL for a given semver version.
 *
 * Format: https://www.help.hirepanther.ca/en/release-notes/{portal}/{major}.{minor}#v{major}-{minor}-{patch}
 */
export function buildVersionUrl(version: string, portal = 'customer'): string {
  const parts = (version || '0.0.0').split('.');
  const major = parts[0] || '0';
  const minor = parts[1] || '0';
  const patch = (parts[2] || '0').replace(/-.*$/, ''); // strip pre-release suffix

  return (
    `https://www.help.hirepanther.ca/en/release-notes/${portal}/` +
    `${major}.${minor}/#v${major}-${minor}-${patch}`
  );
}
